import { useState } from 'react';
import { ComboBox, useTokenSearch } from '../../../src';

const options = ['Apple', 'Orange', 'Lemon', 'Raspberry', 'Strawberry'];

function renderWrapper(
  { key, ...props },
  { expanded },
  { id, 'aria-labelledby': ariaLabelledBy },
) {
  return (
    <div
      key={key}
      {...props}
      role="combobox"
      aria-owns={`${id}_listbox`}
      aria-expanded={expanded ? 'true' : 'false'}
      aria-labelledby={ariaLabelledBy}
    />
  );
}

function renderInput(props, state, { id }) {
  return (
    <input
      {...props}
      role={null}
      aria-expanded={null}
      aria-owns={null}
      aria-controls={`${id}_listbox`}
    />
  );
}

export function Example() {
  const [value, setValue] = useState(null);
  const [search, setSearch] = useState(null);
  const filteredOptions = useTokenSearch(search, { options });

  return (
    <>
      <label
        id="select-label"
        htmlFor="select"
      >
        Select
      </label>
      <ComboBox
        id="select"
        aria-labelledby="select-label"
        value={value}
        onValue={setValue}
        onSearch={setSearch}
        options={filteredOptions}
        renderWrapper={renderWrapper}
        renderInput={renderInput}
      />

      <label htmlFor="output">Current value</label>
      <output
        htmlFor="select"
        id="output"
      >
        {JSON.stringify(value, undefined, ' ')}
      </output>
    </>
  );
}
